<div class="icon-div">
    <app-correct-tick></app-correct-tick>
    <h3 class="title">
        {{data.msg}}
    </h3>
</div>

